import { useEffect, useRef } from "react";

const hasRequiredDetails = (data) => Boolean(
  data?.userName &&
  data?.orgId &&
  data?.clientId &&
  data?.designation
);

const useEnsureAssessmentDetails = (hashId, searchParams) => {
  const hasRequestedDetails = useRef(false);

  useEffect(() => {
    if (!hashId || hasRequestedDetails.current) return;

    const storageKey = `searchParams-${hashId}`;
    const storedData = JSON.parse(localStorage.getItem(storageKey)) || {};
    if (hasRequiredDetails(storedData)) return;

    hasRequestedDetails.current = true;

    const leader = storedData.leader || searchParams?.get("leader") || null;
    const member = storedData.member || searchParams?.get("member") || null;
    const clientName = storedData.clientName || searchParams?.get("client") || null;

    const fetchAssessmentDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URI || "http://localhost:3011"}/v4/user/assessmentAndUser`,
          {
            method: "POST",
            mode: "cors",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              assessmentId: 78,
              userId: 0,
              userHash: hashId,
              userDetails: {
                fullName: "",
                firstName: "",
                lastName: "",
                email: "",
                nameType: "none",
                phone: ""
              },
              firstPage: "assessment",
              pageId: 866,
              designation: "member",
              hasParent: Boolean(leader),
              parentId: leader || 0
            })
          }
        );
        const data = await response.json();
        if (data.status !== "success") return;

        const asmtDetails = data.asmtDetails || {};
        const latestStoredData = JSON.parse(localStorage.getItem(storageKey)) || {};
        localStorage.setItem(storageKey, JSON.stringify({
          ...latestStoredData,
          assessmentId: hashId,
          userName: asmtDetails.userName || latestStoredData.userName || null,
          selfUserName: asmtDetails.userName || latestStoredData.selfUserName || null,
          orgId: asmtDetails.orgid || latestStoredData.orgId || null,
          clientId: asmtDetails.client_id || latestStoredData.clientId || null,
          designation: asmtDetails.designation || latestStoredData.designation || null,
          leader: asmtDetails.leaderName || leader || latestStoredData.leader || null,
          member: asmtDetails.memberName || member || latestStoredData.member || null,
          clientName: asmtDetails.clientName || clientName || latestStoredData.clientName || null
        }));
        window.dispatchEvent(new Event("assessment-details-updated"));
      } catch (error) {
        console.error("Failed to load assessment and user details", error);
      }
    };

    fetchAssessmentDetails();
  }, [hashId, searchParams]);
};

export default useEnsureAssessmentDetails;
